import { Component, Vue, Watch } from "vue-property-decorator";
import { DeliveryModel, CheckoutTranslationModel as TranslationModel } from "../models/deliveryModel";
import { KlarnaCheckoutApi, KlarnaCheckout, KlarnaCheckoutWidget } from "@/models/KlarnaCheckout";
import GoogleEnhancedEcommerce from "../services/GoogleEnhancedEcommerce";
import http from "../services/Http";
import { deliveriesStore } from "@/store/DeliveriesModule";


@Component
export default class HandlingFeeMessageCart extends Vue {
    private url: string = window.location.origin + window.location.pathname;
    constructor() {
        super();
    }

    protected created() {
        http.get<DeliveryModel>(`${this.url}.GetHandlingFeeMessageOnLoad`)
            .then(r => {
                deliveriesStore.dispatchDeliveries(r);
            });
    }
    get handlingFeeMessageInCartSection(): string {
        return deliveriesStore.deliveries && deliveriesStore.deliveries.handlingFeeMessageInCart;
    }

    get handlingFeeCartHeader(): string {
        return deliveriesStore.deliveries && deliveriesStore.deliveries.handlingFeeCartHeader;
    }
}
